import MessageText from "./MessageText";

const MessageImage = ({message, viewImage}) => {
    return message.image_url && <><div className='message-image mt-2' onClick={() => viewImage(message.image_url)}>
            <img alt={message.text} src={message.image_url} className='mb-3'/>
        </div>
        <MessageText text={message.text}/>
    </>
}

export default MessageImage;